import { type FC } from 'react'
import { Marker } from '@react-google-maps/api'
import { Box, Skeleton, useColorScheme } from '@dhl-ui/components'
import { Map } from '@dhl/google-maps'
import { type Servicepoint } from './model.js'
import { ServicepointDistanceChip } from './ServicepointDistanceChip.js'

type Props = {
  height?: number | string
  servicepoint: Servicepoint
}

export const ServicepointMap: FC<Props> = ({ height = '240px', servicepoint }) => {
  const { activePaletteMode } = useColorScheme()

  return (
    <Box position="relative">
      <Map
        mapContainerStyle={{ height }}
        center={{
          lat: servicepoint.geoLocation.latitude,
          lng: servicepoint.geoLocation.longitude,
        }}
        options={{
          disableDefaultUI: true,
          gestureHandling: 'greedy',
          colorScheme: activePaletteMode === 'dark' ? 'DARK' : 'LIGHT',
        }}
        zoom={14}
      >
        <Marker
          position={{
            lat: servicepoint.geoLocation.latitude,
            lng: servicepoint.geoLocation.longitude,
          }}
        />
      </Map>
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <ServicepointDistanceChip color="dark" distance={servicepoint.distance ?? 0} />
      </Box>
    </Box>
  )
}

type SkeletonProps = {
  height?: number | string
}

export const ServicepointMapSkeleton: FC<SkeletonProps> = ({ height = '240px' }) => (
  <Box position="relative">
    <Skeleton variant="rounded" width="100%" height={height} />
  </Box>
)
